export class UserTicketDto {
  name: string;
  phone: number;
  email: string;
  notes: string | null;
  issue: string;
  lineName: string;
  lineQuoteId: string;
  lineId: number;
  accountId: number;



}
